<template>
  <div class="box box-info">
    <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
    <Dialog header="Employee Transfer" :visible.sync="showEmpTrans" @show="checkNepaliDateOrEnglish"
            :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-3">
          <label for="empTransferDate">Transfer Date</label>
          <date-picker v-model="empTransferDate" valueType="format" v-if="!englishDateEnabled"/>
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="empTransferDate"
                     v-model="empTransferDate"/>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="employee">Employee </label>
          <Dropdown v-model="employee" :options="employeeList" optionLabel="name" id="employee"
                    :filter="true" placeholder="Select Group" :showClear="true" @change="setTransferData" v-if="!this.editing"/>
          <Dropdown v-model="employee" :options="employeeList" optionLabel="name" id="employee"
                    :filter="true" placeholder="Select Group" :showClear="true" @change="setTransferData" v-else disabled/>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="empTransferDate">Transfer From Group</label>
          <Dropdown v-model="groupFrom" :options="employeeGroupLists" optionLabel="value" id="warehouse"
                    :filter="true" placeholder="Select Group" :showClear="true" disabled/>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="empTransferDate">Transfer From SubGroup</label>
          <Dropdown v-model="subGroupFrom" :options="employeePositionLists" optionLabel="value" id="warehouse"
                    :filter="true" placeholder="Select Group" :showClear="true" disabled/>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="empTransferDate">Transfer To Group</label>
          <Dropdown v-model="groupTo" :options="employeeGroupLists" optionLabel="value" id="warehouse"
                    :filter="true" placeholder="Select Group" :showClear="true"/>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="empTransferDate">Transfer To SubGroup</label>
          <Dropdown v-model="subGroupTo" :options="employeePositionLists" optionLabel="value" id="warehouse"
                    :filter="true" placeholder="Select Group" :showClear="true"/>
        </div>

        <div class="p-field p-col-12 p-md-3">
          <label for="empTransferDate">Transfer Reason</label>
          <Textarea :autoResize="true" rows="5" cols="30" v-model="transferReason"/>
        </div>
      </div>
      <template #footer>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <Button class="p-button-raised" @click.prevent="employeeTransfer"
                    :label="!editing?'Add':'Update'"/>
            <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
          </div>
        </div>
      </template>
    </Dialog>
    <DataTable
      :value="employeeTransferList"
      :paginator="true"
      :rows="100"
      class="p-datatable-responsive-demo p-datatable-gridlines">
      <Column header="S.N">
        <template #body="slotProps">
          {{ slotProps.index + 1 }}
        </template>
      </Column>
      <Column header="Transfer Date" :sortable="true" field="transferDateNepali"
      />
      <template #empty>
        No records found
      </template>
      <Column header="Transfer From Group" :sortable="true" field="">
        <template #body="sl">
          {{ sl.data.employeeGroupFrom.value }}
        </template>
      </Column>
      <Column header="Transfer From SubGroup" :sortable="true">
        <template #body="sl">
          {{ sl.data.employeeSubGroupFrom.value }}
        </template>
      </Column>
      <Column header="Transfer To Group" :sortable="true">
        <template #body="sl">
          {{ sl.data.employeeGroupTo.value }}
        </template>
      </Column>
      <Column header="Transfer To SubGroup" :sortable="true">
        <template #body="sl">
          {{ sl.data.employeeSubGroupTo.value }}
        </template>
      </Column>
      <Column header="Reason" :sortable="true" field="transferReason"/>
      <Column header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editEmployeeTransfer(slotProps.data)"/>
          <!--          <Button class="p-button-raised p-button-danger"-->
          <!--                  @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>-->
        </template>
      </Column>

    </DataTable>
  </div>
</template>

<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'
import DatePicker from 'vue2-datepicker'
import Textarea from 'primevue/textarea'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default {
  name: 'EmployeeTransfer',
  data() {
    return {
      showEmpTrans: false,
      englishDateEnabled: true,
      empTransferDate: null,
      groupTo: '',
      employee: '',
      subGroupTo: '',
      editing: false,
      eTList: [],
      groupFrom: {},
      subGroupFrom: {},
      transferReason: '',
      empTransferId: null
    }
  },
  computed: {
    employeeGroupLists() {
      return this.$store.state.hr.employeeGroupListsDropdown
    },
    employeeTransferList() {
      return this.$store.state.hr.employeeTransferList
    },
    employeeList() {
      return this.$store.state.hr.employeeDropdownList
    },
    employeePositionLists() {
      return this.$store.state.hr.employeePositionListsDropdown
    }
  },
  mounted() {
    this.employeeGroupList()
    this.employeePositionList()
    this.findEmployeeList()
    this.findEmployeeTransferList()
  },
  methods: {
    openDialog() {
      this.showEmpTrans = true
    },
    async findEmployeeList() {
      await this.$store.dispatch('loadEmployeeDropdownList')
    },
    async findEmployeeTransferList() {
      await this.$store.dispatch('loadEmployeeTransfer')
    },
    async employeePositionList() {
      try {
        await this.$store.dispatch('loadHrMasterForDropdownList', 'EmployeePosition')
      } catch (e) {
      }
    },
    async employeeTransfer() {
      if (this.employee === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please select Employee!', life: 3000})
        return
      }
      if (this.groupTo === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please select Group To!', life: 3000})
        return
      }
      let employeeTransfer = {
        transferDateNepali: this.empTransferDate,
        employeeGroupTo: this.groupTo,
        employeeSubGroupTo: this.subGroupTo,
        transferReason: this.transferReason,
        employeeId: this.employee,
        id: this.empTransferId
      }
      let res = ''
      if (!this.editing) {
        res = await this.$store.dispatch('createEmployeeTransfer', employeeTransfer)
      } else {
        res = await this.$store.dispatch('updateEmployeeTransfer', employeeTransfer)
      }
      if (res.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: res.data.message, life: 3000})
      } else {
        this.$toast.add({severity: 'danger', summary: '', detail: res.data.message, life: 3000})
      }
      this.reset()
    },
    editEmployeeTransfer(data) {
      this.editing = true
      this.transferReason = data.transferReason
      this.empTransferDate = data.transferDateNepali
      this.groupTo = data.employeeGroupTo
      this.subGroupTo = data.employeeSubGroupTo
      this.showEmpTrans = true
      this.employee = data.employeeId
      this.groupFrom = data.employeeGroupFrom
      this.subGroupFrom = data.employeeSubGroupFrom
      this.empTransferId = data.id
    },
    async setTransferData() {
      let resp = await this.$store.dispatch('loadEmployeeDataById', this.employee.id)
      this.groupFrom = resp.data.data.employeeGroupFrom
      this.subGroupFrom = resp.data.data.employeeSubGroupFrom
    },
    cancel() {
      this.showEmpTrans = false
      this.reset()
    },
    async employeeGroupList() {
      try {
        await this.$store.dispatch('loadHrMasterForDropdownList', 'EmployeeGroup')
      } catch (e) {
        this.$toast.add({severity: 'success', summary: '', detail: 'Something went Wrong!', life: 3000})
      }
    },
    checkNepaliDateOrEnglish() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    reset() {
      this.groupTo = ''
      this.subGroupTo = ''
      this.employee = ''
      this.groupFrom = {}
      this.subGroupFrom = {}
      this.transferReason = ''
      this.empTransferDate = null
      this.editing = false
      this.showEmpTrans = false
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.empTransferDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.empTransferDate = new Date().toISOString().slice(0, 10)
    },
    nepaliDate() {
      $('#empTransferDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.empTransferDate = $('#startDate').val()
        }
      })
    }
  },
  components: {
    Dialog,
    Button,
    InputMask,
    DatePicker,
    Dropdown,
    Textarea,
    DataTable,
    Column
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EmployeeTransfer.vue?a6de5e42